import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import ComicCard from '@/components/base/ComicCard';
import { comics, categories, siteInfo } from '@/mocks/comics';

export default function Home() {
  const hotComics = comics.filter((c) => c.isHot);
  const newComics = comics.filter((c) => c.isNew);
  const recommendedComics = comics.filter((c) => c.isRecommended);
  const topRated = [...comics].sort((a, b) => b.rating - a.rating).slice(0, 6);
  const latestUpdates = [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, 6);

  return (
    <>
      <ScrollToTop />
      <Header />
      <main>
        <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20style%20illustration%20with%20warm%20coral%20and%20amber%20tones%2C%20abstract%20geometric%20shapes%2C%20soft%20gradient%20from%20light%20cream%20to%20warm%20peach%2C%20clean%20modern%20aesthetic%2C%20subtle%20paper%20texture%2C%20artistic%20background%20suitable%20for%20comic%20reading%20website%20hero&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
            alt="韩漫在线"
            className="w-full h-full object-cover object-top"
            title="韩漫在线 - 免费韩国漫画大全"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/45"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-3 md:mb-4">
              韩漫在线
            </h1>
            <p className="text-sm md:text-lg text-white/85 max-w-xl mb-3 md:mb-4 leading-relaxed">
              免费韩国漫画大全，支持全集下拉式阅读，随时随地畅享海量韩漫资源
            </p>
            <p className="text-xs md:text-sm text-white/60 max-w-lg mb-5 md:mb-6">
              收录数千部精品韩漫，涵盖恋爱、奇幻、动作、搞笑等多种类型，每日持续更新
            </p>
            <div className="flex items-center gap-3 flex-wrap justify-center">
              <Link
                to="/category/all"
                className="px-6 py-2.5 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                开始阅读
              </Link>
              <Link
                to="/about"
                className="px-6 py-2.5 border border-white/30 text-white rounded-full text-sm font-medium hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
              >
                了解更多
              </Link>
            </div>
          </div>
        </section>

        <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-3 md:py-4">
          <div className="flex items-center gap-2 md:gap-3 overflow-x-auto pb-2 flex-wrap">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={cat.slug === 'all' ? '/category/all' : `/category/${cat.slug}`}
                className="flex items-center gap-1.5 px-3 py-2 rounded-lg bg-background-100 hover:bg-accent-100 text-foreground-600 hover:text-accent-700 transition-colors text-xs md:text-sm whitespace-nowrap cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${cat.icon} text-xs md:text-sm`}></i>
                </div>
                {cat.name}
              </Link>
            ))}
          </div>
        </section>

        <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-8 md:py-10">
          <div className="flex items-center justify-between mb-5 md:mb-6">
            <div>
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950">
                热门推荐
              </h2>
              <p className="text-xs md:text-sm text-foreground-500 mt-1">
                大家都在看的韩漫作品
              </p>
            </div>
            <Link
              to="/category/all"
              className="flex items-center gap-1 text-xs md:text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看全部
              <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-5">
            {hotComics.map((comic) => (
              <ComicCard key={comic.slug} comic={comic} />
            ))}
          </div>
        </section>

        <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-8 md:py-10 bg-background-100/70 rounded-2xl">
          <div className="flex items-center justify-between mb-5 md:mb-6">
            <div>
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950">
                最新上架
              </h2>
              <p className="text-xs md:text-sm text-foreground-500 mt-1">
                刚上线的新鲜韩漫
              </p>
            </div>
            <Link
              to="/category/all"
              className="flex items-center gap-1 text-xs md:text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看全部
              <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-5">
            {newComics.length > 0 ? (
              newComics.map((comic) => (
                <ComicCard key={comic.slug} comic={comic} />
              ))
            ) : (
              topRated.filter(c => !c.isHot).slice(0, 6).map((comic) => (
                <ComicCard key={comic.slug} comic={comic} />
              ))
            )}
          </div>
        </section>

        <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-8 md:py-10">
          <div className="flex items-center justify-between mb-5 md:mb-6">
            <div>
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950">
                编辑精选
              </h2>
              <p className="text-xs md:text-sm text-foreground-500 mt-1">
                品质保证，值得一读
              </p>
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-5">
            {recommendedComics.map((comic) => (
              <ComicCard key={comic.slug} comic={comic} />
            ))}
          </div>
        </section>

        <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-8 md:py-10 bg-background-100/70 rounded-2xl">
          <div className="flex items-center justify-between mb-5 md:mb-6">
            <div>
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950">
                最近更新
              </h2>
              <p className="text-xs md:text-sm text-foreground-500 mt-1">
                最新连载，追更不停
              </p>
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-5">
            {latestUpdates.map((comic) => (
              <ComicCard key={comic.slug} comic={comic} />
            ))}
          </div>
        </section>

        <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
          <div className="bg-gradient-to-r from-primary-500 to-accent-500 rounded-2xl p-8 md:p-12 text-center">
            <h2 className="text-lg md:text-xl font-heading font-bold text-white mb-3">
              海量韩漫，免费畅读
            </h2>
            <p className="text-sm md:text-base text-white/85 max-w-2xl mx-auto mb-6 leading-relaxed">
              韩漫在线已收录超过{siteInfo.totalComics.toLocaleString()}部韩漫作品，服务超过{Math.floor(siteInfo.totalUsers / 10000)}万用户。无论你喜欢什么类型，都能在这里找到心仪的作品，享受流畅的下拉式阅读体验。
            </p>
            <div className="flex items-center justify-center gap-8 md:gap-16">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-white">
                  {siteInfo.totalComics.toLocaleString()}+
                </div>
                <div className="text-xs md:text-sm text-white/70 mt-1">漫画作品</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-white">
                  {Math.floor(siteInfo.totalUsers / 10000)}万+
                </div>
                <div className="text-xs md:text-sm text-white/70 mt-1">注册用户</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-white">
                  {Math.floor(siteInfo.totalViews / 100000000)}亿+
                </div>
                <div className="text-xs md:text-sm text-white/70 mt-1">累计阅读</div>
              </div>
            </div>
          </div>
        </section>

        <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
          <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950 text-center mb-8">
            用户口碑
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {[
              { name: '小王', rating: 5, content: '韩漫在线真的是我的宝藏网站！更新速度快，画质清晰，下拉式阅读体验太舒服了。强烈推荐给所有喜欢韩漫的朋友！', date: '2026-07-28', avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20woman%20portrait%20avatar%2C%20soft%20smile%2C%20warm%20lighting%2C%20clean%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-testimonial-01&orientation=squarish' },
              { name: '小李', rating: 5, content: '没想到有专门做韩漫的网站，分类很详细，想看的漫画基本都能找到。而且全部免费，真的太良心了！', date: '2026-07-25', avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20man%20portrait%20avatar%2C%20friendly%20expression%2C%20warm%20lighting%2C%20clean%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-testimonial-02&orientation=squarish' },
              { name: '小张', rating: 5, content: '下拉式阅读模式真的太好用了，比传统翻页方便太多。每天通勤路上看几话韩漫已经成为我的日常习惯。', date: '2026-07-20', avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20woman%20portrait%20avatar%2C%20bright%20smile%2C%20warm%20lighting%2C%20clean%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-testimonial-03&orientation=squarish' },
              { name: '小刘', rating: 4, content: '漫画资源很丰富，界面也很简洁好看。希望以后能增加更多完结的漫画作品，有些追更中的等得太着急了哈哈。', date: '2026-07-15', avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20man%20portrait%20avatar%2C%20casual%20smile%2C%20warm%20lighting%2C%20clean%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-testimonial-04&orientation=squarish' },
            ].map((review, idx) => (
              <div key={idx} className="p-5 rounded-xl bg-background-100">
                <div className="flex items-center gap-3 mb-3">
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div>
                    <div className="text-sm font-medium text-foreground-900">{review.name}</div>
                    <div className="text-xs text-foreground-500">{review.date}</div>
                  </div>
                </div>
                <div className="flex gap-0.5 mb-2">
                  {Array.from({ length: review.rating }).map((_, i) => (
                    <div key={i} className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-star-fill text-accent-500 text-xs"></i>
                    </div>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{review.content}</p>
              </div>
            ))}
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '韩漫在线',
            url: 'https://hanmanonline.com',
            description: '韩漫网提供免费韩国漫画大全，支持全集下拉式阅读，让您在线畅读各种韩漫。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://hanmanonline.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '韩漫在线',
            url: 'https://hanmanonline.com',
            description: '国内领先的韩国漫画免费阅读平台。',
            contactPoint: {
              '@type': 'ContactPoint',
              email: 'contact@hanmanonline.com',
              contactType: 'customer service',
            },
          }),
        }}
      />
    </>
  );
}